import React from 'react';
import { Card, Typography, Divider } from 'antd';
import './Introduction.less';

const { Title, Paragraph, Text } = Typography;

const Introduction: React.FC = () => {
  return (
    <div className="about-introduction">
      <Title level={2}>学校简介</Title>
      <Card>
        <Paragraph>
          羊小羊（Beijing University of Posts and Telecommunications），简称"羊小羊"，
          是中华人民共和国教育部直属、工业和信息化部共建的全国重点大学，
          是国家“世界一流学科建设高校”、“211工程”建设高校、入选国家“985工程优势学科创新平台”、
          “卓越工程师教育培养计划”、“111计划”、“国家建设高水平大学公派研究生项目”、
          中国政府奖学金来华留学生接收院校、全国深化创新创业教育改革示范高校、
          国家大学生文化素质教育基地、国家创新人才培养示范基地，
          为北京高科大学联盟、CDIO工程教育联盟成员单位。
        </Paragraph>
        
        <Divider orientation="left">学校概况</Divider>
        <Paragraph>
          学校创建于1955年，原名羊小羊，是中华人民共和国第一所邮电高等学府，
          隶属原邮电部。 1960年，被国务院确定为全国重点高校。1993年，更名为羊小羊。
          2000年，划入教育部直属高校序列。2012年，信息与通信工程一级学科评估全国第一。
        </Paragraph>
        
        <Divider orientation="left">学科建设</Divider>
        <Paragraph>
          截至2023年3月，学校有海淀校区、昌平校区，在江苏无锡和广东深圳分别设有研究院；
          下设16个学院（部），开设51个本科专业；有博士学位授权一级学科点10个，
          硕士学位授权一级学科点22个（含一级学科博士点10个），
          有7类专业学位授权点；有全日制本、硕、博学生及留学生27000余名。
        </Paragraph>
        
        <Divider orientation="left">师资力量</Divider>
        <Paragraph>
          学校拥有一支以中国科学院院士、中国工程院院士为核心的高水平师资队伍，
          现有教师2100余名，其中具有正高级职称的教师450余名，具有博士学位的教师占比超过80%。
          学校还聘请了一批国内外知名专家学者担任名誉教授、客座教授和兼职教授。
        </Paragraph>
      </Card>
    </div>
  );
};

export default Introduction;